import Media from "./media";

export const MediaEvents = Media;
